<template>
  <div>
    <router-view/>
  </div>
</template>

<script>
export default {
}
</script>
<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// src/components/loginAutoLayout.vue